"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("../../../utils/classnames"));
require("./InputChip.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var InputChip = function InputChip(_ref) {
  var _classnames;
  var label = _ref.label,
    color = _ref.color,
    errorMessage = _ref.errorMessage,
    interactive = _ref.interactive,
    invalid = _ref.invalid,
    onClick = _ref.onClick,
    onDelete = _ref.onDelete;
  var classes = (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, color, color != null), _defineProperty(_classnames, "interactive", interactive), _defineProperty(_classnames, "invalid", invalid), _classnames));
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'uin-input-chip ' + classes,
    onClick: onClick
  }, label, errorMessage && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chp-error"
  }, errorMessage), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close",
    onClick: onDelete
  }));
};
InputChip.propTypes = {
  label: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].oneOf(['blue', 'green']),
  errorMessage: _propTypes["default"].string,
  interactive: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onDelete: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = InputChip;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/InputChip/InputChip.js
// module id = 594
// module chunks = 0